import { getApiConfig } from "../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import { call, CallEffect, PutEffect, select } from "redux-saga/effects";
import { ReducersTypes } from "@/redux/reducers/Models";

export interface Fetch {
    plate: string;
    callback: (success: boolean, code?: string) => void;
}

export interface RequestDebtsAction {
    type: string;
    payload: Fetch;
}

export default function* requestDebts({
    payload,
}: RequestDebtsAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        const getCustomer = (state: ReducersTypes) => state.customerReducer;
        // @ts-expect-error
        const customer: ReducersTypes['customerReducer'] = yield select(getCustomer);
        const isLogged = Boolean(customer?.accessToken);

        const data = { licensePlate: payload.plate };
        const { apiInstance, prefixUri } = getApiConfig(isLogged);
        const response = yield call(apiInstance.post, `${prefixUri}/v1/vehicle-debts/start`, data);

        if (response?.data?.data) {
            yield call(payload.callback, true, response?.data?.data);
        } else {
            yield call(payload.callback, false, "error");
        }

    } catch (error) {
        yield call(payload.callback, false, "timeout");
    }
}